export enum LanguageNames {
	'ab-ge' = 'аҧсуа',
	'af' = 'Afrikaans',
	'am' = 'አማርኛ',
	'ar' = 'العربية',
	'ar-ae' = 'العربية (الإمارات)',
	'ar-sa' = 'العربية (السعودية)',
	'ast-es' = 'Asturianu',
	'az' = 'Azərbaycan dili',
	'ba-ru' = 'Башҡорт теле',
	'be-by' = 'Беларуская мова',
	'bg' = 'Български',
	'bn' = 'বাংলা',
	'bs' = 'Bosanski',
	'ca' = 'Català',
	'ckb' = 'کوردیی ناوەندی',
	'ckb-iq' = 'کوردی ناوەندی (عێراق)',
	'ckb-ir' = 'کوردی ناوەندی (ئیران)',
	'cnh' = 'Chin Hakha',
	'cs' = 'Čeština',
	'cy' = 'Cymraeg',
	'da' = 'Dansk',
	'de' = 'Deutsch',
	'de-ch' = 'Deutsch (Schweiz)',
	'el' = 'Ελληνικά',
	'en' = 'English',
	'en-ab' = 'English (Scottish)',
	'en-au' = 'English (Australia)',
	'en-gb' = 'English (United Kingdom)',
	'en-ie' = 'English (Ireland)',
	'en-in' = 'English (India)',
	'en-nz' = 'English (New Zealand)',
	'en-wl' = 'English (Welsh)',
	'en-za' = 'English (South Africa)',
	'es' = 'Español',
	'es-419' = 'Español (Latinoamérica)',
	'es-es' = 'Español (España)',
	'es-mx' = 'Español (México)',
	'et' = 'Eestlane',
	'eu-es' = 'Euskara',
	'fa' = 'فارسی',
	'fa-af' = 'فارسی (افغانستان)',
	'fa-ir' = 'فارسی (ایران)',
	'fi' = 'Suomi',
	'fr' = 'Français',
	'fr-ca' = 'Français (Canada)',
	'ga' = 'Gaeilge',
	'gl-es' = 'Galego',
	'gu' = 'ગુજરાતી',
	'ha' = 'Hausa',
	'he' = 'עברית',
	'he-il' = 'עברית (ישראל)',
	'hi' = 'हिन्दी',
	'hmn' = 'Hmong',
	'hr' = 'Hrvatski',
	'ht' = 'Kreyòl Ayisyen',
	'hu' = 'Magyar',
	'hy' = 'Հայերեն',
	'id' = 'Bahasa Indonesia',
	'is' = 'Íslenska',
	'it' = 'Italiano',
	'ja' = '日本語',
	'ka' = 'ქართველი',
	'kab-dz' = 'ⵍⵣⵣⵓⵏ',
	'kar' = 'Karen',
	'kk' = 'Қазақ тілі',
	'kn' = 'ಕನ್ನಡ',
	'ko' = '한국어',
	'ku-kmr' = 'Kurmanji',
	'ky-kg' = 'Кыргыз тили',
	'lg-in' = 'Luganda',
	'lt' = 'Lietuvis',
	'lv' = 'Latvietis',
	'mhr-ru' = 'Марий',
	'mk' = 'Македонски',
	'ml' = 'മലയാളം',
	'mn' = 'Монгол',
	'mr' = 'मराठी',
	'ms' = 'Bahasa Melayu',
	'mt' = 'Malti',
	'my' = 'ဗမာ',
	'ne' = 'नेपाली',
	'nl' = 'Nederlands',
	'no' = 'Norsk',
	'or-in' = 'ଓଡ଼ିଆ',
	'pa' = 'ਪੰਜਾਬੀ',
	'pl' = 'Polski',
	'prs' = 'دری',
	'ps' = 'پښتو',
	'pt' = 'Português',
	'pt-br' = 'Português (Brasil)',
	'ro' = 'Română',
	'ru' = 'Русский',
	'rw-rw' = 'Kinyarwanda',
	'si' = 'සිංහල',
	'sk' = 'Slovenčina',
	'sl' = 'Slovenščina',
	'so' = 'Soomaali',
	'sq' = 'Shqiptare',
	'sr' = 'Српски',
	'su-id' = 'Basa Sunda',
	'sv' = 'Svenska',
	'sw' = 'Kiswahili',
	'sw-bi' = 'Kiswahili (Burundi)',
	'sw-ke' = 'Kiswahili (Kenya)',
	'sw-rw' = 'Kiswahili (Rwanda)',
	'sw-tz' = 'Kiswahili (Tanzania)',
	'sw-ug' = 'Kiswahili (Uganda)',
	'ta' = 'தமிழ்',
	'te' = 'తెలుగు',
	'th' = 'ไทย',
	'tl' = 'Filipino (Tagalog)',
	'tr' = 'Türkçe',
	'tt-ru' = 'Татар теле',
	'ug-cn' = 'ئۇيغۇر تىلى',
	'uk' = 'Український',
	'ur' = 'اردو',
	'uz' = 'Oʻzbekcha',
	'vi' = 'Tiếng Việt',
	'wo' = 'Wollof',
	'yi' = 'ייִדיש',
	'zh' = '中文',
	'zh-cmn-hans' = '中文普通话简体',
	'zh-hk' = '繁體中文（香港）',
	'zh-tw' = '中文 (Traditional)',
	'zu-za' = 'isiZulu'
}


export const RIGHT_TO_LEFT_LANGUAGE_CODES = ['ar', 'ar-ae', 'ar-sa', 'he', 'he-il', 'fa', 'fa-ir', 'fa-af', 'ur', 'ps', 'prs', 'ckb', 'ckb-iq', 'ckb-ir', 'ug-cn', 'yi'];
